import { Fragment, useState, useLayoutEffect, useRef, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import debounce from 'transmute/debounce';
import { DownIcon, UpIcon } from 'foundations-assets';
import VerticalBar from '../../common/VerticalBar';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROW_HEIGHT = 24;
const TransparencyBarComponents = ({
  transparencyBarComponents
}) => {
  const componentsContainer = useRef(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isCollapsable, setIsCollapsable] = useState(false);
  const updateIsCollapsable = useCallback(() => {
    // when the rendered content is more then one row, it should be allowed to be collapsed
    if (componentsContainer !== null && componentsContainer !== void 0 && componentsContainer.current) {
      setIsCollapsable((componentsContainer === null || componentsContainer === void 0 ? void 0 : componentsContainer.current.clientHeight) > ROW_HEIGHT);
    }
  }, [componentsContainer]);
  useLayoutEffect(() => {
    const debouncedupdateIsCollapsable = debounce(50, updateIsCollapsable);
    window.addEventListener('resize', debouncedupdateIsCollapsable);
    return () => window.removeEventListener('resize', debouncedupdateIsCollapsable);
  }, [updateIsCollapsable]);
  useLayoutEffect(() => {
    updateIsCollapsable();
  }, [transparencyBarComponents, updateIsCollapsable]);
  if (transparencyBarComponents.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    inlineSize: "100%",
    gap: "300",
    alignItems: "baseline",
    "data-selenium-test": "FiltersBarTransparencyBarContainer",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 1,
      "data-test-id": "transparencyBar-componentsContainer",
      ref: componentsContainer,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        flexWrap: "wrap",
        overflow: "hidden",
        alignItems: "center",
        blockSize: isCollapsed ? `${ROW_HEIGHT}px` : 'auto',
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.quickFiltersBar.filteredBy"
          })
        }), transparencyBarComponents.map((transparencyBarComponent, index) => {
          return /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(VerticalBar, {
              marginInlineStart: "200",
              marginInlineEnd: "200"
            }), transparencyBarComponent]
          }, `${index}-transparencyBar`);
        })]
      })
    }), (isCollapsed || isCollapsable) && /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "transparencyBar-collapseButton",
      onClick: () => setIsCollapsed(prev => !prev),
      placement: "right",
      use: "link",
      children: isCollapsed ? /*#__PURE__*/_jsx(DownIcon, {
        size: "500"
      }) : /*#__PURE__*/_jsx(UpIcon, {
        size: "500"
      })
    })]
  });
};
export default TransparencyBarComponents;